// extracted by mini-css-extract-plugin
export default {"emailText":"style_emailText__sGwSB","emailInputBox":"style_emailInputBox__jeG35"};